import React, { useEffect, useRef, useState } from 'react';
import { cn, useOutsideClick } from '../../utils/helper';
import { ChevronDownIcon } from '@heroicons/react/24/outline';

const FormSelect = ({
  options = [],
  label,
  onChange,
  name,
  value,
  placeholder = 'Select',
  disabled,
  className
}) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(value);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const val = options?.find((option) => option.value === value);
    if (val) {
      setSelected(val.name);
    }
  }, [value]);

  useOutsideClick(wrapperRef, (e) => {
    setOpen(false);
  });

  const handleChange = (value) => {
    onChange?.(name, value);
    const val = options.find((option) => option.value === value);
    setSelected(val.name);
    setOpen(false);
  };

  return (
    <div className="flex flex-col gap-4">
      <label className="font-medium">{label}</label>
      <div
        className={cn(
          'db-selected-item relative flex flex-col justify-between items-center px-4 pr-5 border border-shoorah-borderGray h-[40px] bg-shoorah-normanGray dark:bg-shoorah-darkBgColor dark:border-transparent rounded-lg cursor-pointer',
          className
        )}
        onClick={(e) => {
          if (!disabled) {
            e.stopPropagation();
            setOpen((prev) => !prev);
          }
        }}
        ref={wrapperRef}
      >
        <div className="flex justify-between w-full h-full items-center">
          <span className={`db-selected-value overflow-hidden whitespace-nowrap overflow-ellipsis pr-2 text-[14px]
           font-medium  ${!selected ? "text-[#9ca3af]":"text-shoorah-lightBlack"} dark:text-shoorah-darkBg`}>
            {selected || placeholder}
          </span>
          <div className="w-4 h-4">
            <ChevronDownIcon
              className={`w-4 h-4 transform transition-transform duration-200 ${open ? 'rotate-180' : ''
                }`}
            />
          </div>
        </div>
        {open && (
          <ul
            className="absolute top-full max-h-[200px] overflow-auto left-0 w-full h-fit overflow-y-auto border dark:border-transparent bg-white dark:bg-shoorah-darkBgColor border-shoorah-borderGray rounded-lg mt-2 z-10"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
          >
            {options?.map((option, index) => (
              <li
                key={index}
                className="px-4 py-2 text-[14px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg hover:bg-[#E7E8EA] dark:hover:bg-shoorah-darkGray cursor-pointer overflow-hidden whitespace-nowrap overflow-ellipsis"
                title={option.name}
                onClick={handleChange.bind(null, option.value)}
              >
                {option.name}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default FormSelect;
